/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { ESRAreYouSureComponent} from './ESR_are_you_sure.component';

export class ESRAreYouSureValidation extends IValidator {

       constructor(private component: ESRAreYouSureComponent) {
             super();
       }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            // add your valdation here!

            return this.success;

       }
}

